angular.module('elfium').service('reportContentService', ['reportPhasesByTaskTypeFilter', 'TASK_TYPES', 'REPORT_PHASE', 'REPORT_REALIZATION',
    function (reportPhasesByTaskTypeFilter, TASK_TYPES, REPORT_PHASE, REPORT_REALIZATION) {
        var that = this;
        that.taskTypes = [TASK_TYPES.KOTEVRENI, TASK_TYPES.POTREBA, TASK_TYPES.NABIDKA, TASK_TYPES.KUZAVRENI];
        that._rowIsFilled = function (row) {
            return row.date && row.volume;
        };
        that._isFirstRowFilled = function (reports, taskType, reportPhase, reportRealization) {
            var rows = reports[taskType] && reports[taskType][reportPhase] && reports[taskType][reportPhase][reportRealization];
            return rows && rows.length && that._rowIsFilled(rows[0]);
        };
        that._isBlockFilled = function (reports, taskType, reportRealization) {
            var isFilled = true;
            var reportPhases = reportPhasesByTaskTypeFilter(taskType);
            angular.forEach(reportPhases, function (reportPhase) {
                isFilled = isFilled && that._isFirstRowFilled(reports, taskType, reportPhase, reportRealization);
            });
            return isFilled;
        };
        that.isPlanFilled = function (reports) {
            var isFilled = true;
            angular.forEach(that.taskTypes, function (taskType) {
                isFilled = isFilled && that._isBlockFilled(reports, taskType, REPORT_REALIZATION.PLAN);
            });
            return isFilled;
        };        
        that.hasFirstItemInPlan = function (reports) {
            return that._isFirstRowFilled(reports, TASK_TYPES.KOTEVRENI, REPORT_PHASE.OTEVRENI_PRIPADU, REPORT_REALIZATION.PLAN);
        };
        that.hasFirstItemInActual = function (reports) {
            return that._isFirstRowFilled(reports, TASK_TYPES.KOTEVRENI, REPORT_PHASE.OTEVRENI_PRIPADU, REPORT_REALIZATION.ACTUAL);
        };
        that.hasTerminPrvniSchuzkyInActual = function (reports) {
            return that._isFirstRowFilled(reports, TASK_TYPES.KOTEVRENI, REPORT_PHASE.DOMLUV_PRVNI_SCHUZKA, REPORT_REALIZATION.ACTUAL);
        };
        that.hasPotrebaInActual = function (reports) {
            return that._isBlockFilled(reports, TASK_TYPES.POTREBA, REPORT_REALIZATION.ACTUAL);
        };
        that.hasNabidkaInActual = function (reports) {
            return that._isBlockFilled(reports, TASK_TYPES.NABIDKA, REPORT_REALIZATION.ACTUAL);
        };
        that.hasKUzavreniInActual = function (reports) {
            return that._isBlockFilled(reports, TASK_TYPES.KUZAVRENI, REPORT_REALIZATION.ACTUAL);
        };

        that._hasAnyRowValue = function (reports, taskType, reportPhase, reportRealization) {
            var hasValue = false;
            var rows = reports[taskType] && reports[taskType][reportPhase] && reports[taskType][reportPhase][reportRealization];
            angular.forEach(rows, function (row) {
                hasValue = hasValue || that._rowIsFilled(row);
            });
            return hasValue;
        };
        that.actualHasValues = function (reports) {
            var hasValue = false;
            angular.forEach(that.taskTypes, function (taskType) {
                var reportPhases = reportPhasesByTaskTypeFilter(taskType);
                angular.forEach(reportPhases, function (reportPhase) {
                    hasValue = hasValue || that._hasAnyRowValue(reports, taskType, reportPhase, REPORT_REALIZATION.ACTUAL);
                });
            });
            return hasValue;
        };
        that._isNotFirstPhase = function (phase) {
            return phase != REPORT_PHASE.OTEVRENI_PRIPADU;
        };
        that._reportByPhaseActualHasNoEmptyFields = function (reportByPhase) {
            var isFilled = true;
            angular.forEach(reportByPhase.actual, function (row) {
                isFilled = isFilled && that._rowIsFilled(row);
            });
            return isFilled;
        };
        that.isLockingAllowed = function (reports, phase, reportByPhase) {
            return that._isNotFirstPhase(phase) && that._reportByPhaseActualHasNoEmptyFields(reportByPhase) && that._arePreviousPhasesLocked(reports, phase);
        };
        that._arePreviousPhasesLocked = function (reports, phase) {
            for (var i = 0; i < that.taskTypes.length; i++) {
                var taskType = that.taskTypes[i];
                var reportPhases = reportPhasesByTaskTypeFilter(taskType);
                for (var reportPhaseKey in reportPhases) {
                    var reportPhase = reportPhases[reportPhaseKey];
                    if (reportPhase == phase) {
                        return true;
                    } else if (reportPhase != REPORT_PHASE.OTEVRENI_PRIPADU && !reports[taskType][reportPhase].actual[0].isLocked) {
                        return false;
                    }
                }
            }
            return false;
        };
        that.lockReport = function (phase, reportByPhase) {
            angular.forEach(reportByPhase[phase].actual, function (actual) {
                actual.isLocked = true;
            });
            if (phase === REPORT_PHASE.DOMLUV_PRVNI_SCHUZKA) {
                angular.forEach(reportByPhase[REPORT_PHASE.OTEVRENI_PRIPADU].actual, function (actual) {
                    actual.isLocked = true;
                });
            }
        };
        that.isActualLocked = function (reports) {
            var isLocked = true;
            for (var i = 0; i < that.taskTypes.length; i++) {
                var taskType = that.taskTypes[i];
                var reportPhases = reportPhasesByTaskTypeFilter(taskType);
                for (var reportPhaseKey in reportPhases) {
                    var reportPhase = reportPhases[reportPhaseKey];
                    if (reports[taskType] && reports[taskType][reportPhase]) {
                        for (var j = 0; j < reports[taskType][reportPhase].actual.length; j++) {
                            isLocked = isLocked && reports[taskType][reportPhase].actual[j].isLocked;
                        }
                    } else {
                        isLocked = false;
                    }
                }
            }
            return isLocked;
        };
        that.isActualFilled = function (reports) {
            var isFilled = true;
            angular.forEach(TASK_TYPES, function (taskType) {
                isFilled = isFilled && that._isBlockFilled(reports, taskType, REPORT_REALIZATION.ACTUAL);
            });
            return isFilled;
        };  
    }
]);


// WEBPACK FOOTER //
// ./src/app/components/report/reportContentService.ts